/* Standard product duos reuse the patch offer's verified cart transport and lock.
   Prices come from Shopify; discounted or personalised offers are not accepted here. */
(() => {
  function register() {
    if (!window.K9NativeOffer || customElements.get('k9-product-offer')) return;
    class K9ProductOffer extends window.K9NativeOffer.Base {
      static requiresOptions = false;
      static items(config, mode, choices) {
        if (mode !== 'bundle' || config.products.primary.id === config.products.secondary.id) return null;
        const items = [];
        for (const key of ['primary', 'secondary']) {
          const variant = config.products[key].variants.find(v => String(v.id) === String(choices[key]));
          if (!variant?.available) return null;
          items.push({ id: variant.id, quantity: 1 });
        }
        return items;
      }

      static validation() { return null; }
      nativeFields() { return {}; }
      synchronise() {}
      reflect() {}
      showFieldError() {}
    }
    customElements.define('k9-product-offer', K9ProductOffer);
  }
  // Both assets use defer. The drawer loads the base after the product content;
  // DOMContentLoaded runs once both deferred scripts have finished.
  if (window.K9NativeOffer) register();
  else document.addEventListener('DOMContentLoaded', register, { once: true });
})();
